<template><div><h1>VUX V2.3.3 released</h1>
<h2><a href="/en/components/badge.html">Badge</a></h2>
<ul><li>[feature] Use dot styles if no text is specified</li>
</ul>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Support slot:title</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] Support slot:popup-header</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[enhance] Set max-height:100% by default</li>
<li>[feature] Support prop:max-height</li>
<li>[fix] disable mask scrolling on mobile #1475 @xiaobinhong1</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[enhance] set placeholder color. #1465</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.3-102.vue?7cf994c6